import baseApi from "../api/baseApi";

const categoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCategory: builder.query({
      query: ({ page = 1, limit = 100 } = {}) => ({
        url: `/category/`,
        method: "GET",
      }),
      providesTags: ["Categories"],
    }),

    getAllAgeGroups: builder.query({
      query: () => ({
        url: "/category/agegroups",
        method: "GET",
      }),
      providesTags: ["Categories"],
    }),

    getAllLevels: builder.query({
      query: () => ({
        url: "/category/levels/",
        method: "GET",
      }),
      providesTags: ["Categories"],
    }),
  }),
});

export const {
  useGetAllCategoryQuery,
  useGetAllAgeGroupsQuery,
  useGetAllLevelsQuery,
} = categoryApi;

export default categoryApi;
